<form [formGroup]="searchForm" class="actions">
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>{{ 'PROJECTS.project-list.actions.search' | translate }}</mat-label>
    <input matInput formControlName="search" autocomplete="not" />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>
</form>

<app-task-table
  [tasks]="(myTasks$ | async) ?? []"
  [filter]="searchForm.controls['search'].value"
  [showCustomer]="true"
  displayMode="AssignedToCurrentUser"
/>
